import React from "react";
import { createRouter } from "@tanstack/react-router";
import { QueryCache, QueryClient } from "@tanstack/react-query";
import { ErrorComponent } from "./error-component";
import { routeTree } from "../routeTree.gen";
import { showRequestErrorToast } from "./error-toast";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: any, query) => {
      if (query?.meta?.hideToast) {
        return;
      }
      showRequestErrorToast(error);
    },
  }),
});

export type RouterContext = { queryClient: typeof queryClient };

// Create a new router instance
export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultErrorComponent: ({ error }) => <ErrorComponent error={error} />,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export const TanStackRouterDevtools =
  process.env.NODE_ENV === "production"
    ? () => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import("@tanstack/router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      );
